/**
 * LE SCEAU DE CIRE. Une tache de cire pressée, jamais un cercle parfait.
 *
 * Il marque ce qui est clos : une mort, une aventure finie, un pacte signé. La cire est un dégradé
 * radial passé au filtre de bord déchiré ; l'empreinte est un signe simple, en creux.
 */
export type Empreinte = "mort" | "pacte" | "fin" | "chronique";

const EMPREINTES: Record<Empreinte, string> = {
  mort: "M20 12c5 0 8.5 3.5 8.5 8 0 2.6-1.4 4.4-2.8 5.5v3.5H14.3V25.5C12.9 24.4 11.5 22.6 11.5 20c0-4.5 3.5-8 8.5-8zM17 20.5h.01M23 20.5h.01",
  pacte: "M12 27c5-1.5 9.5-4.5 12.5-8.5 1.3-1.8 2-3.6 2-5-2 .4-4 1.2-6 2.8-2.6 2.2-5.4 5.6-8.5 10.7zM15 24l4-4",
  fin: "M11 20l6 6 12-13",
  chronique: "M20 11v18M14 15h12M20 8a2.2 2.2 0 1 1 0 4.4A2.2 2.2 0 0 1 20 8M11 22a9 9 0 0 0 18 0"
};

export function Sceau({ empreinte, taille = 64, titre }: { empreinte: Empreinte; taille?: number; titre: string }) {
  return (
    <svg width={taille} height={taille} viewBox="0 0 40 40" role="img" aria-label={titre}>
      {/* Le disque n'est pas rond : la cire s'écrase où elle veut. */}
      <path
        className="sceau__cire"
        d="M20 2.5c6.5 0 11.5 2.5 14.5 7.5 3 5 3 12-1 16.5S22.5 37.5 16 36 4 29 2.5 22 4 8.5 9 5c3-2 7-2.5 11-2.5z"
      />
      <path className="sceau__empreinte" d={EMPREINTES[empreinte]} />
    </svg>
  );
}
